import PropTypes from "prop-types";
import { Box, Typography, Button } from "@mui/material";
import dayjs from "dayjs";

import CalculationResultAttribute from "./CalculationResultAttribute";

import { useClient } from "../../../context/ClientProvider";


function ChangePaymentDateConfirmation({ liveAccount, response }) {

  const { useGetConfig } = useClient();
  const { clientConfig } = useGetConfig();

  return (
    <>
      <Box>
        <Typography sx={{
          fontSize: 18,
          fontWeight: "bold",
          mb: 2,
          color: clientConfig?.layout?.primaryButtonBackgroundColour
        }}>
          Your repayment date has been changed.
        </Typography>
        <Typography sx={{ fontSize: 16, mb: 2 }}>
          Here's a summary of your new repayment schedule:
        </Typography>
      </Box>
      <Box sx={{ width: { xs: "100%", sm: "50%" }, pt: 1 }}>
        <Box sx={{ pt: 1 }}>
          <CalculationResultAttribute
            id="new-repayment-date"
            title="New repayment date:"
            value={dayjs(response?.newDueDate).format("DD/MM/YYYY")}
          />
        </Box>
        <Box sx={{ pt: 1 }}>
          <CalculationResultAttribute
            id="new-next-repayment-due-date"
            title="New next repayment due date:"
            value={dayjs(response?.newNextDueDate).format("DD/MM/YYYY")}
          />
        </Box>
        <Box sx={{ pt: 1 }}>
          <CalculationResultAttribute
            id="next-repayment-amount"
            title="Next repayment amount:"
            value={`£${response?.newAmountDue}`}
          />
        </Box>
        <Box sx={{ pt: 1 }}>
          <CalculationResultAttribute
            id="regular-repayment-amount"
            title="Regular repayment amount:"
            value={`£${liveAccount?.amountDue}`}
          />
        </Box>
        <Box sx={{ pt: 1 }}>
          <CalculationResultAttribute
            id="new-loan-term-end-date"
            title="New loan term end date:"
            value={dayjs(response?.newMaturityDate).format("DD/MM/YYYY")}
          />
        </Box>
      </Box>
      <Box sx={{ pt: 5 }}>        
        <Button
          id="return-home-btn"
          onClick={() => window.location.href = '/'}
          variant="contained"
          sx={{
            textTransform: "none",
            borderRadius: clientConfig?.layout?.buttonBorderRadius,
            width: { xs: "15em", lg: "20em" },
            backgroundColor: clientConfig?.layout?.primaryButtonBackgroundColour,
            color: clientConfig?.layout?.primaryButtonColour,
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            "&:hover": {
              backgroundColor: clientConfig?.layout?.hoverPrimaryButtonBackgroundColour,
              color: clientConfig?.layout?.hoverPrimaryButtonColour
            }
          }}
        >
          Return Home
        </Button>
      </Box>
    </>
  )
};

ChangePaymentDateConfirmation.propTypes = {
  liveAccount: PropTypes.object.isRequired,
  response: PropTypes.object.isRequired,
};

export default ChangePaymentDateConfirmation;